<template>
  <div class="smartcard-display">
    <div class="row">
      <div class="col-sm-12">
        <div class="toolbar pull-right">
          <span v-if="smartcard.Account">
            <router-link class="btn btn-default" :to="{ path: '/membership/smartcards/reassign/' + smartcard.uuid }">
              <span class="fa fa-sync fa-fw"></span> Reassign Card
            </router-link>
            <button class="btn btn-default" @click="unassignCard()" type="button"><span class="fa fa-ban fa-fw"></span> Unassign Card</button>
          </span>
          <router-link v-else class="btn btn-default" :to="{ path: '/membership/smartcards/reassign/' + smartcard.uuid }">
            <span class="fa fa-credit-card fa-fw"></span> Assign Card
          </router-link>
          <router-link class="btn btn-default" :to="{ path: '/membership/smartcards/edit/' + smartcard.uuid }">
            <span class="fa fa-edit fa-fw"></span> Edit Card
          </router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">SmartCard</h1>
            <div class="box-tools pull-right">
            </div>
          </div>
          <div class="box-body">
            <table class="table table-condensed">
              <tr>
                <td><strong>Card Number</strong></td>
                <td>{{ smartcard.chipId }}</td>
              </tr>
              <tr>
                <td><strong>Card ID</strong></td>
                <td>{{ smartcard.cardNumber }}</td>
              </tr>
              <tr>
                <td><strong>Member</strong></td>
                <td>
                  <router-link v-if="smartcard.Account" :to="{ path: '/membership/members/' + smartcard.Account.uuid }" class="btn-link">
                    {{ smartcard.Account.dropdownLabel }}
                  </router-link>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SmartcardDisplay',
  data () {
    return {
      smartcard: {
        chipId: '',
        cardNumber: '',
        account: '',
        Account: {
          uuid: ''
        }
      }
    }
  },
  route: {
    data () {
      let params = this.$route.params
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.get(`${meta.authType}/object/smartcard`, { params }).then(({ data }, status, request) => {
        this.smartcard = data.object
      })
    }
  },
  methods: {
    unassignCard () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/smartcard/unassign`, { smartcard_id: this.smartcard.uuid }).then((response, status, request) => {
        this.$router.push('/membership/smartcards')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/SmartcardDisplay.vue